import styled from '@emotion/styled'

import { mediaDown, mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'
import { FontFamilyStyles, H3, Text2 } from '@/styles/typography'

export const Wrapper = styled.div`
  ${FontFamilyStyles};
  position: absolute;
  display: block;
  background-color: ${colors.paleGrey};
  border-radius: 28px;
  text-decoration: none;
  width: 209px;
  min-height: 212px;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%);

  ${mediaUp('lg')} {
    width: 300px;
    min-height: 319px;
  }
`

export const ImageWrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 114px;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;

  img {
    object-fit: cover;
  }

  ${mediaUp('lg')} {
    height: 162px;
  }
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 13px;

  ${mediaUp('lg')} {
    padding: 23px;
  }
`

export const IconWrapper = styled.div`
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background-color: ${colors.white};
  margin-inline-end: 18px;
  flex-shrink: 0;

  ${mediaDown('lg')} {
    display: none;
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`

export const ParkingInfo = styled.div``

export const ButtonWrapper = styled.div`
  width: 151px;
  margin: 0 auto 13px;

  ${mediaUp('lg')} {
    width: 172px;
    margin-bottom: 23px;
  }
`

export const Title = styled(H3)`
  margin-bottom: 4px;
  font-size: 14px;

  ${mediaUp('lg')} {
    margin-bottom: 6px;
    font-size: 16px;
  }
`

export const SubText = styled(Text2)`
  font-size: 12px;
  ${mediaUp('lg')} {
    font-size: 14px;
  }
`
